import "bootstrap/dist/css/bootstrap.min.css";
import "jquery/dist/jquery.min.js";
import "popper.js/dist/popper.min";
import "bootstrap/dist/js/bootstrap.min.js";
import "./src/styles/sass/main.scss";

const addScript = url => 
{
    const script = document.createElement("script")
    script.src = url
    script.async = true
    document.body.appendChild(script)
}
  
export const onClientEntry = () => 
{
    window.onload = () => 
    {
        addScript("https://kit.fontawesome.com/f07522b7ab.js");
    }
} 

/*
export const shouldUpdateScroll = ({ routerProps: { location }, getSavedScrollPosition }) => 
{    
    window.scrollTo(0, 0)
    return false
}*/